<script>
    import Response from './response.svelte';
    export let data;

</script>

<div class='block-question'>
    <h2 class='question'>{data.question}</h2>

    <div class='circle-grid'>

        {#if (data.featureyesanswers )}
            <Response
                summary= {data.featureyesanswers + ' answered yes'}
                respondents={Number(data.respondents)}
                fillTotal={ data.featureyesanswers}
            />
        {:else if (data.featurenoanswers )}
            <Response
                summary= {data.featurenoanswers + ' answered no'}
                respondents={Number(data.respondents)}
                fillTotal={ data.featurenoanswers}
            />
        {/if}

        {#if data.fewer}
            <Response
                summary= {data.fewer + ` serve fewer meals`}
                respondents={data.fewer}
                fillTotal={ data.fewer}
            />

            <Response
                summary= {data.same + ` serve about the same number`}
                respondents={data.same}
                fillTotal={ data.same}
            />

            <Response
                summary= {data.more + ` serve more meals`}
                respondents={data.more}
                fillTotal={ data.more}
            />


        {/if}

        {#if data.nearlyall}
            <Response
                summary= {data.nearlyall + ' answered nearly all'}
                respondents={Number(data.respondents)}
                fillTotal={ data.nearlyall}
            />

            <Response
                summary= {data.morethanhalf + ` answered more than half`}
                respondents={data.morethanhalf}
                fillTotal={ data.morethanhalf}
            />

            <Response
                summary= {data.abouthalf + ` answered about half`}
                respondents={data.abouthalf}
                fillTotal={ data.abouthalf}
            />

            <Response
                summary= {data.dontknow + " answered don't know"}
                respondents={data.dontknow}
                fillTotal={ data.dontknow}
            />

        {/if}

        <p class='responses'>{data.respondents} responses</p>
    </div>
</div>

<div class='block-quote'>
    <p class='quote'>{data.quote}</p>
    {#if data.attribution}
    <div class='quote-name'>{data.attribution}</div>
    {/if}
    <div class='quote-title'>{data.title}</div>
    <div class='quote-location'>{data['municipality']}</div>
</div>
